/* eslint-disable arrow-body-style */
// @ts-check
import { computed } from 'vue';
import { useGetters } from 'vuex-composition-helpers/dist';
import { ROLE } from '@/composables/user/constants';

export function useUserRole() {
  const { user } = useGetters({
    user: 'user/user',
  });

  /**
   * @returns {import('vue').ComputedRef<string>}
   */
  const role = computed(() => {
    return user.value?.role;
  });

  /**
   * @returns {import('vue').ComputedRef<boolean>}
   */
  const isSuperAdmin = computed(() => {
    return role.value === ROLE.SUPER_ADMIN;
  });

  /**
   * @returns {import('vue').ComputedRef<boolean>}
   */
  const isAdmin = computed(() => {
    return isSuperAdmin.value || role.value === ROLE.ADMIN;
  });

  /**
   * @returns {import('vue').ComputedRef<boolean>}
   */
  const isUser = computed(() => {
    return isSuperAdmin.value || isAdmin.value || role.value === ROLE.USER;
  });

  function hasRole(givenRole) {
    if (givenRole === ROLE.SUPER_ADMIN) {
      return isSuperAdmin.value;
    }
    if (givenRole === ROLE.ADMIN) {
      return isAdmin.value;
    }
    if (givenRole === ROLE.USER) {
      return isUser.value;
    }
    return false;
  }

  return {
    role,
    isSuperAdmin,
    isAdmin,
    isUser,
    hasRole,
  };
}
